import PropTypes from 'prop-types';
import React from 'react';

import Formsy from 'formsy-react';
import { SheetFooter, Row, Col, Button, Label, FormGroup, SheetBody, Tabs, TabsList, TabsTrigger, TabsContent, SimpleAlert } from 'twyne-new.ui';

import URLView from '@Components/InputCopyURL';
import Input from '@Components/form/Input';
import Switch, { PureSwitch } from '@Components/form/Switch';

const RESOURCE_OPTIONS = [
  { key: 'preflight', label: 'Preflight' },
]

class TokenForm extends React.Component {
  componentDidMount() {
    const { data } = this.props;
    this.syncData(data)
  }

  componentWillReceiveProps(nextProps) {
    const { data } = nextProps;
    this.syncData(data)
  }

  syncData = data => {
  if (data) {
      const permissions = data.meta?.permissions || {}

      this.setState({
        ...data,
        meta: {
          ...data.meta,
          permissions: {
            all: permissions.all ?? true,
            resources: permissions.resources || [],
          },
        },
      })
    }
  }

  handleValidSubmit = model => {
    const permissions = {
      ...this.state.meta?.permissions,
      ...model.meta?.permissions,
    }
    const all = permissions.all ?? true

    this.props.handleSubmit({
      ...this.state,
      ...model,
      meta: {
        ...this.state.meta,
        ...model.meta,
        permissions: all ? { all } : { all, resources: this.state.meta?.permissions?.resources || [] },
      },
    });
  }

  handleToggleAll = checked => {
    this.setState(({ meta }) => ({
      meta: {
        ...meta,
        permissions: {
          ...meta?.permissions,
          all: checked,
          resources: checked ? [] : meta?.permissions?.resources,
        },
      },
    }))
  }

  handleToggleResource = (key, checked) => {
    this.setState(({ meta }) => {
      const resources = meta?.permissions?.resources || []
      const nextResources = checked ? [...new Set([...resources, key])] : resources.filter(resource => resource !== key)

      return {
        meta: {
          ...meta,
          permissions: {
            ...meta?.permissions,
            all: checked ? false : meta?.permissions?.all,
            resources: nextResources,
          },
        },
      }
    })
  }

  render() {
    return (
      <Formsy onValidSubmit={this.handleValidSubmit}>
        <SheetBody>
          <Tabs defaultValue='general' forceMount>
            <TabsList>
              <TabsTrigger className='pt-0' value='general'>General</TabsTrigger>
              <TabsTrigger className='pt-0' value='permissions'>Permissions</TabsTrigger>
            </TabsList>
            <TabsContent value='general'>
              {this.state?.id && <SimpleAlert variant='warning'>
                You've just this chance to copy this token, when modal close we not provide another chance to copy!
              </SimpleAlert>}
              <Row>
                <Col size="12">
                  <FormGroup>
                    <Label>
                      Token
                    </Label>
                    <URLView value={this.state?.id} label="token" />
                  </FormGroup>
                </Col>
                <Col size="12">
                  <FormGroup>
                    <Label>
                      Description
                    </Label>
                    <Input name='description' value={this.state?.description || ''} />
                  </FormGroup>
                </Col>
                <Col size="3">
                  <FormGroup>
                    <Label>
                      Active
                    </Label>
                    <Switch name="active" value={this.state?.active ?? true} />
                  </FormGroup>
                </Col>
              </Row>
            </TabsContent>
            <TabsContent value='permissions'>
              <Row>
                <Col size="4">
                  <div className='flex items-center gap-2 py-1'>
                    <Switch name="meta.permissions.all" value={this.state?.meta?.permissions?.all ?? true} onChange={this.handleToggleAll} />
                    <Label>All</Label>
                  </div>
                </Col>
                {RESOURCE_OPTIONS.map(({ key, label }) => <Col size="4" key={key}>
                  <div className='flex items-center gap-2 py-1'>
                    <PureSwitch
                      value={this.state?.meta?.permissions?.resources?.includes(key) || false}
                      onChange={e => this.handleToggleResource(key, e.target.checked)}
                    />
                    <Label>{label}</Label>
                  </div>
                </Col>)}
              </Row>
            </TabsContent>
          </Tabs>
        </SheetBody>
        <SheetFooter>
          <Button onClick={this.props.onCancel} variant='ghost'>Cancel</Button>
          <Button type="submit" color='accent'>Save</Button>
        </SheetFooter>
      </Formsy>
    );
  }
}

TokenForm.propTypes = {
  handleSubmit: PropTypes.func,
  onCancel: PropTypes.func.isRequired,
  data: PropTypes.any,
};

export default TokenForm;
